import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import {Provider} from "react-redux";
import store from "./redux/Store";
import { getLoginUserSession } from "./redux/actions/AuthActions";
import Amplify from "aws-amplify";
import awsmobile from "./aws-exports";
import "react-table/react-table.css";
require("dotenv").config();

Amplify.configure(awsmobile);
//Amplify.Logger.LOG_LEVEL = (process.env.REACT_APP_ENV !== 'production' || process.env.REACT_APP_ENV !== 'development') ? 'DEBUG' : '';

store.dispatch(getLoginUserSession());

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>,
    document.getElementById("root"));
serviceWorker.unregister();
